import type { CSSProperties } from "react";

export const TV_ZOOM_MIN = 50;
export const TV_ZOOM_MAX = 200;
export const TV_ZOOM_STEP = 10;

function boundedZoomPercent(zoomPercent: number): number {
  if (!Number.isFinite(zoomPercent)) return 100;
  return Math.min(TV_ZOOM_MAX, Math.max(TV_ZOOM_MIN, zoomPercent));
}

export function stepTvZoom(zoomPercent: number, direction: -1 | 1): number {
  return boundedZoomPercent(zoomPercent + direction * TV_ZOOM_STEP);
}

export function browserZoomStyle(zoomPercent: number): CSSProperties {
  const scale = boundedZoomPercent(zoomPercent) / 100;
  const logicalSize = `${100 / scale}%`;

  return {
    width: logicalSize,
    height: logicalSize,
    transform: `scale(${scale})`,
  };
}

export function playerLogicalViewport(
  viewportWidth: number,
  viewportHeight: number,
  canvasWidth: number,
): { width: number; height: number; scale: number } {
  const safeCanvasWidth = Number.isFinite(canvasWidth) && canvasWidth > 0 ? canvasWidth : 1960;
  const safeViewportWidth =
    Number.isFinite(viewportWidth) && viewportWidth > 0 ? viewportWidth : safeCanvasWidth;
  const safeViewportHeight =
    Number.isFinite(viewportHeight) && viewportHeight > 0 ? viewportHeight : safeViewportWidth;
  return {
    width: safeCanvasWidth,
    height: (safeCanvasWidth * safeViewportHeight) / safeViewportWidth,
    scale: safeViewportWidth / safeCanvasWidth,
  };
}
